export default "__VITE_ASSET__3OyXI1sX__"